/* ===============================
  iia-drawer 監視 + UI差し替え（フルコード）
  - drawer 出現を監視 → 見つけたらUI更新 + MutationObserver
  - 閉じるボタン(.iia-drawer-close)クリックでObserver停止 → 監視を再開
================================ */

// console.log("👀 iia-drawer 監視スクリプトを起動します...");

let drawerObserver = null;
let drawerInterval = null;

/* ========= 店舗名 → 住所/マップ HTML ========= */
const extractLocation = (text) => {
  const locationMap = {
    '熊本': `<span>熊本県熊本市中央区下通1-3-8 1F</span><a href="https://maps.app.goo.gl/Qcfvjj7SwUm1owDx9" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
    '宮崎': `<span>宮崎県宮崎市橘通東3-4-1 うみ館 1F</span><a href="https://maps.app.goo.gl/EMWLxNUes9W5anJW7" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
    '天文館': `<span>鹿児島県鹿児島市千日町1-1 2F</span><a href="https://maps.app.goo.gl/8RADkikGeTWPXDHz9" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
    'ももち': `<span>福岡県福岡市中央区地行浜2-2-1 2F</span><a href="https://maps.app.goo.gl/noFTV7MySWKFBLc16" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
    '大分': `<span>大分県大分市要町1-14 3F</span><a href="https://maps.app.goo.gl/X4fN6UcfkM4w6ngg6" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
  };

  for (const location of Object.keys(locationMap)) {
    if (text.includes(location)) return locationMap[location];
  }
  return '';
};

/* ========= UI更新（まとめ） ========= */
const updateUI = () => {
  replaceH2Text();
  addStockInfo();
  addStockInfoToSection();
  replaceAddressText();
  addLocationText();
  hideOnlineTitleText();
  hideOnlineTitleText2();
};

/* ========= h2 タイトル差し替え ========= */
const replaceH2Text = () => {
  const h2Element = document.querySelector(".iia-drawer-header h2");
  if (h2Element && h2Element.textContent !== "店舗在庫を確認") {
    h2Element.textContent = "店舗在庫を確認";
    console.log("✅ h2 のテキストを変更しました");
  }
};

/* ========= 注意文 + 連絡先をヘッダー直後に追加 ========= */
const addStockInfo = () => {
  const header = document.querySelector(".iia-drawer-header");
  if (header && !document.querySelector(".iia-stock-info")) {
    const stockInfo = document.createElement("p");
    stockInfo.innerHTML =
      "残りわずかと表示されている商品は、売り切れの可能性がございます。<br>" +
      "お電話にてお問い合わせください。<br>" +
      "店舗名の表示がない場合は、売り切れかお取り扱いの無い商品となります。<br>" +
      '<span class="iia-drawer-tel">お問い合わせ<br><span style="font-size: 1.2rem;">TEL：<span class="tel-number"><a href="tel:05088950236" aria-label="電話 050-8895-0236" style="color:#121212BF;">050-8895-0236</a></span>（平日：10:00~19:00）</span><br><span style="font-size: 1.2rem;">MAIL：info@crossjewellia.co.jp（2営業日以内にご返信）</span></span>';

    stockInfo.className = "iia-stock-info";
    header.insertAdjacentElement("afterend", stockInfo);
    console.log("✅ 在庫情報を追加しました");
  }
};

/* ========= セクション内に短い注記を追加 ========= */
const addStockInfoToSection = () => {
  const section = document.querySelector(".iia-drawer-header-section");
  if (section && !document.querySelector(".iia-stock-info-section")) {
    const stockInfo = document.createElement("p");
    stockInfo.textContent = "在庫の詳細は各店舗にお問い合わせください。";
    stockInfo.className = "iia-stock-info-section";
    section.insertAdjacentElement("afterend", stockInfo);
    console.log("✅ セクション内に在庫情報を追加しました");
  }
};

/* ========= 既存の住所表示を置換（住所 + マップ） ========= */
const replaceAddressText = () => {
  document.querySelectorAll(".iia-address:not(.address-replaced)").forEach((element) => {
    const text = element.textContent.trim();

    const addressMap = {
      '熊本': `<span>熊本県熊本市中央区下通1-3-8 1F</span><a href="https://maps.app.goo.gl/oVzSC8Lt2XToUorGA" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
      '宮崎': `<span>宮崎県宮崎市橘通東3-4-1 みやざき うみ館 1F</span><a href="https://maps.app.goo.gl/vAiy5Vb4vP7urQvC9" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
      '天文館': `<span>鹿児島県鹿児島市千日町1-1 2F</span><a href="https://maps.app.goo.gl/6zpBsWvfwFFFd72G6" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
      'ももち': `<span>福岡県福岡市中央区地行浜2-2-1 2F</span><a href="https://maps.app.goo.gl/1ZxXwficeX7oLKbv6" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
      '大分': `<span>大分県大分市要町1-14 3F</span><a href="https://maps.app.goo.gl/i25zpxUaiLWEWbo18" class="iia-list-maps"><img src="https://cdn.shopify.com/s/files/1/0582/2575/4206/files/maps.png?v=1771479693"><span>マップ</span></a>`,
    };

    for (const [key, value] of Object.entries(addressMap)) {
      if (text.includes(key)) {
        element.innerHTML = value;
        element.classList.add("address-replaced");
        console.log(`✅ 住所を ${key} に変更しました`);
        break;
      }
    }
  });
};

/* ========= 店舗見出しの直後に「住所詳細」を追加 ========= */
const addLocationText = () => {
  document.querySelectorAll(".iia-groupby-header.iia-location:not(.location-updated)").forEach((header) => {
    const locationText = header.textContent.trim();
    if (!locationText) return;

    const locationDiv = document.createElement("div");
    locationDiv.className = "iia-location-text";
    locationDiv.innerHTML = extractLocation(locationText);

    // extractLocation が空の時は追加しない
    if (!locationDiv.innerHTML) return;

    header.insertAdjacentElement("afterend", locationDiv);
    header.classList.add("location-updated");
    console.log("✅ 住所の詳細を追加しました！");
  });
};

/* ========= オンラインストアの表示を潰す（1） ========= */
const hideOnlineTitleText = () => {
  document.querySelectorAll(".iia-location-info").forEach((element) => {
    if (element.textContent.includes("オンラインストア")) {
      element.style.height = "0";
      element.style.padding = "0";
      element.style.margin = "0";
      element.style.overflow = "hidden";
      element.style.visibility = "hidden";
    }
  });
};

/* ========= オンラインストアの表示を潰す（2） ========= */
const hideOnlineTitleText2 = () => {
  document.querySelectorAll(".iia-list-item").forEach((element) => {
    if (element.textContent.includes("オンラインストア")) {
      element.style.height = "0";
      element.style.padding = "0";
      element.style.margin = "0";
      element.style.overflow = "hidden";
      element.style.visibility = "hidden";
    }
  });
};

/* ========= 閉じるボタンを押したら監視を再開 ========= */
const watchDrawerClose = () => {
  const closeBtn = document.querySelector(".iia-drawer-close");
  if (!closeBtn) return;

  // 多重登録防止
  if (closeBtn.dataset.watched === "true") return;
  closeBtn.dataset.watched = "true";

  closeBtn.addEventListener("click", () => {
    console.log("❌ drawer close を検知 → 監視を再開します");

    // Observer停止
    if (drawerObserver) {
      drawerObserver.disconnect();
      drawerObserver = null;
      console.log("🛑 MutationObserver を停止しました");
    }

    // 次の open に備えて再監視
    startDrawerWatch();
  });
};

/* ========= drawer 出現監視（何度でも再起動できる） ========= */
const startDrawerWatch = () => {
  // すでに interval が動いているなら重複起動しない
  if (drawerInterval) return;

  console.log("👀 iia-drawer を探しています...");

  drawerInterval = setInterval(() => {
    const drawer = document.querySelector(".iia-drawer");
    if (!drawer) return;

    console.log("✅ iia-drawer が見つかりました！");
    clearInterval(drawerInterval);
    drawerInterval = null;

    // 初回UI更新
    updateUI();

    // 既存Observerが残ってたら念のため停止
    if (drawerObserver) {
      drawerObserver.disconnect();
      drawerObserver = null;
    }

    // drawer 内の更新に追従（重くなりやすい attributes は外す）
    drawerObserver = new MutationObserver(() => {
      updateUI();
    });

    drawerObserver.observe(drawer, {
      childList: true,
      subtree: true
    });

    // 閉じるボタン監視
    watchDrawerClose();
  }, 500);
};

/* ========= 起動 ========= */
startDrawerWatch();
